import script from "./PlansTable.vue?vue&type=script&setup=true&lang=js"
export * from "./PlansTable.vue?vue&type=script&setup=true&lang=js"

import "./PlansTable.vue?vue&type=style&index=0&id=a47fffee&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a47fffee"]])

export default __exports__